<template>
  <div class="home-news1">
    <p class="hy-title">新闻动态</p>
    <div class="news-content">
      <div v-if="!newsList.length" class="news-content__empty">暂无新闻</div>
      <template v-else>
        <div class="news-content__body" @click="handleClick(activeNews)">
          <h3 class="news-content__title">{{ activeNews.title }}</h3>
          <p class="news-content__desc">
            {{ stripHtml(activeNews.content, 120) }}
          </p>
        </div>
        <div class="news-content__footer">
          <router-link class="news-content__more" to="/news">
            更多新闻&nbsp;&nbsp;<span class="el-icon-right"></span>
          </router-link>
          <div class="news-content__pager">
            <span class="news-content__pager-num">
              <span style="color: #f43608">{{ activeIndex + 1 }} </span>/
              {{ newsList.length }}
            </span>
            <button
              type="button"
              class="news-content__arrow"
              :class="{ 'is-disabled': !canPrev }"
              :disabled="!canPrev"
              aria-label="上一条新闻"
              @click="prevNews"
            >
              <span class="el-icon-caret-left"></span>
            </button>
            <button
              type="button"
              class="news-content__arrow"
              :class="{ 'is-disabled': !canNext }"
              :disabled="!canNext"
              aria-label="下一条新闻"
              @click="nextNews"
            >
              <span class="el-icon-caret-right"></span>
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { htmlToPlainExcerpt } from "@/utils/richContent";
export default {
  name: "HomeNews1",
  data() {
    return {
      newsList: [],
      activeIndex: 0,
    };
  },
  computed: {
    activeNews() {
      return this.newsList[this.activeIndex] || null;
    },
    canPrev() {
      return this.activeIndex > 0;
    },
    canNext() {
      return this.activeIndex < this.newsList.length - 1;
    },
  },
  created() {
    this.getNewsList();
  },
  methods: {
    handleClick(item) {
      if (!item) return;
      this.$router.push(`/news/${item.id}`);
    },
    prevNews() {
      if (!this.canPrev) return;
      this.activeIndex -= 1;
    },
    nextNews() {
      if (!this.canNext) return;
      this.activeIndex += 1;
    },
    async getNewsList() {
      try {
        this.newsList = (await api.getNewsList(1, 6)) || [];
        this.activeIndex = 0;
      } catch (error) {
        console.log(error);
      }
    },
    stripHtml(text, len) {
      return htmlToPlainExcerpt(text, len);
    },
  },
};
</script>

<style lang="less">
@import "@/assets/styles/variables.less";

.home-news1 {
  height: 316px;
  margin: 0 120px;
  margin-top: 50px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 6px rgba(201, 201, 201, 0.25);
  .hy-title {
    margin-bottom: 70px;
  }

  .news-content {
    // width: 100%;
    // max-width: 946px;

    padding: 0 40px 0;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .news-content__empty {
    color: rgba(153, 153, 153, 1);
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    padding: 40px 0;
  }

  .news-content__body {
    cursor: pointer;
  }

  .news-content__title {
    height: 30px;
    line-height: 30px;
    font-size: 30px;
    margin-bottom: 20px;
    font-weight: 400;
    color: @red;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .news-content__desc {
    height: 75px;
    font-size: 24px;
    color: rgba(153, 153, 153, 1);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .news-content__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;
  }

  .news-content__more {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 154px;
    height: 44px;
    background-image: url(data:image/png;base64,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);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 172px 62px;
    color: #fff;
    font-size: 18px;
  }

  .news-content__more-arrow {
    font-size: 18px;
    line-height: 1;
  }

  .news-content__pager {
    display: flex;
    align-items: center;
  }

  .news-content__pager-num {
    min-width: 48px;
    font-size: 22px;
    line-height: 1;
    color: rgba(204, 204, 204, 1);
    text-align: center;
  }

  .news-content__arrow {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 30px;
    padding: 0;
    border: none;
    background: transparent;
    color: rgba(153, 153, 153, 1);
    cursor: pointer;
    transition: color 0.2s ease, opacity 0.2s ease;
    font-size: 24px;
    &.is-disabled,
    &:disabled {
      color: rgba(204, 204, 204, 1);
      cursor: not-allowed;
      opacity: 0.8;
    }

    &:not(:disabled):hover {
      opacity: 1;
    }
  }
}
</style>
